import { CreativeType } from '../common/typings';
import { CreativeOptionsData, CreativeOptionsGroupValue } from '../CreativeOptions/typings';

import {
    AddAdaptiveCreativeState,
    AddCommonCreativeState,
    AddCreativeState,
    AddOverlayCreativeState,
    AddVideoCreativeState
} from './typings';

export const selectCreativeOptions = (state: AddCreativeState): CreativeOptionsData => {
    const { creativeOptions } = state;

    if (!creativeOptions) {
        throw 'Creative options is not defined!';
    }

    return creativeOptions;
};

export const selectVideoOrOverlayCreativeState = (
    state: AddCreativeState
): AddVideoCreativeState | AddOverlayCreativeState => {
    switch (state.type) {
        case CreativeType.VIDEO_ADDITION:
            return selectVideoCreativeState(state);
        case CreativeType.OVERLAY:
            return selectOverlayCreativeState(state);

        default:
            throw 'Creative type is not supported!';
    }
};

export const selectOverlayCreativeState = (state: AddCreativeState): AddOverlayCreativeState => {
    switch (state.type) {
        case CreativeType.OVERLAY:
            return state;

        default:
            throw 'Creative type is not supported!';
    }
};

export const selectVideoCreativeState = (state: AddCreativeState): AddVideoCreativeState => {
    switch (state.type) {
        case CreativeType.VIDEO_ADDITION:
            return state;

        default:
            throw 'Creative type is not supported!';
    }
};

export const selectCommonCreativeState = (state: AddCreativeState): AddCommonCreativeState => {
    switch (state.type) {
        case CreativeType.COMMON:
        case CreativeType.CPM_GEOPRODUCT:
            return state;

        default:
            throw 'Creative type is not supported!';
    }
};

export const selectGraphicCreativeState = (
    state: AddCreativeState
): AddCommonCreativeState | AddAdaptiveCreativeState => {
    switch (state.type) {
        case CreativeType.COMMON:
        case CreativeType.CPM_GEOPRODUCT:
        case CreativeType.ADAPTIVE:
            return state;

        default:
            throw 'Creative type is not supported!';
    }
};

export const selectAdaptiveCreativeState = (state: AddCreativeState): AddAdaptiveCreativeState => {
    switch (state.type) {
        case CreativeType.ADAPTIVE:
            return state;

        default:
            throw 'Creative type is not supported!';
    }
};

export const selectCreativeOptionGroupValue = (
    options: CreativeOptionsData,
    groupName: string
): CreativeOptionsGroupValue => {
    const optionGroupValue = options.optionsValue.find((value: CreativeOptionsGroupValue) => value.type === groupName);

    if (!optionGroupValue) {
        throw "Couldn't find an option to change!";
    }

    return optionGroupValue;
};
